export enum CaseDocumentTypes {
    Unknown = '00000000-0000-0000-0000-000000000000',
    Config = '00000000-0000-0000-0000-000000000001',
    Attachment = '00000000-0000-0000-0000-000000000002',
    Integration = '00000000-0000-0000-0000-000000000003',
}

